import React from "react";
import classNames from "classnames";
import { Error } from "../content";
import RequirementIndicator from "./RequirementIndicator";

const Dropdown = ({
  id,
  label,
  onChange,
  disabled,
  required,
  value,
  tabIndex,
  data,
  errorText,
  hasError,
  optionLabel = "- Select -",
  className = "",
  dataTestId,
  displayRequirementIndicator = false,
}) => {
  return (
    <div
      id={`${id}__container`}
      className={classNames(className ? className : "col-sm-6 pb-2")}
    >
      <label className="form-label" htmlFor={id}>
        {label}
        {displayRequirementIndicator && (
          <RequirementIndicator required={required} />
        )}
      </label>
      <select
        id={id}
        name={id}
        onChange={onChange}
        tabIndex={tabIndex}
        required={required}
        disabled={disabled}
        value={value}
        data-testid={dataTestId || id}
        className={classNames("form-control form-select", {
          "bg-danger-subtle border-danger-subtle": hasError,
        })}
      >
        {(data.length > 1 ||
          disabled ||
          (data.length === 1 && id === "model")) && (
          <option value="">{optionLabel}</option>
        )}
        {data.length &&
          data.map((value, key) => {
            return (
              <option key={key} value={value}>
                {value}
              </option>
            );
          })}
      </select>
      {hasError && <Error id={id} text={errorText} />}
    </div>
  );
};

export default Dropdown;
